import { lazy, Suspense, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import { ContentContext } from '@parcel2go/npm-p2g-app';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '~/routes/use-on-load';
import { P2GBox } from '@parcel2go/core-ui';
import useSmartSendAnalytics from '~/hooks/use-smartsend-analytics';

// Consumer-view "Billing" tab inside the My Account area. Surfaces the existing Invoices /
// Statements component (ReportingOverview) as-is; the SmartSend /billing page is untouched.
const ReportingOverview = lazy(() => import('~/apps/smartsend/components/reporting/ReportingOverview'));

export default function Component() {
  const { track } = useSmartSendAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { t } = useTranslation(TranslationNamespaces.MYDETAILS);

  useOnLoad(() => {
    const title = t('BILLING_PAGE_TITLE', { defaultValue: 'Billing' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.BILLING });
    navigationDispatch({
      type: 'INITIALISE_NAVIGATION',
      payload: { title: title, currentPageRoute: RoutingConstants.Billing }
    });
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.Billing
      }
    });
  });

  return (
    <Tagged tag="screen-billing">
      <Suspense>
        <P2GBox>
          <ReportingOverview />
        </P2GBox>
      </Suspense>
    </Tagged>
  );
}

Component.displayName = 'Billing';
